"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const Animations_1 = require("components/styled/Animations");
const Colors_1 = require("components/styled/Colors");
const Fonts_1 = require("components/styled/Fonts");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const TitleBase = styled_components_1.default.div `
  font-family: ${Fonts_1.WalsheimFontStack};
  font-weight: 500;
`;
exports.HeroTitle = styled_components_1.default(TitleBase) `
  animation: ${Animations_1.fadein(0, 15)} 1.5s ease-out;
  color: ${Colors_1.MAKO};
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 16px;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    animation: ${Animations_1.fadein(0, 15)} 1s ease-in-out;
    margin-bottom: 8px;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    font-size: 48px;
    line-height: 48px;
    margin-bottom: 12px;
  }

  ${ScreenSizes_1.DESKTOP} {
    font-size: 62px;
    line-height: 62px;
  }
`;
exports.SectionTitle = styled_components_1.default(TitleBase) `
  color: ${props => props.color || Colors_1.MAKO};
  font-size: 32px;
  line-height: 32px;
  margin-bottom: 16px;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin-bottom: 12px;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    font-size: 48px;
    line-height: 48px;
  }

  ${ScreenSizes_1.DESKTOP} {
    font-size: 62px;
    line-height: 62px;
    margin-bottom: 24px;
  }
`;
const TextBase = styled_components_1.default.div `
  font-family: ${Fonts_1.SpaceMonoFontStack};
  font-variant-ligatures: no-common-ligatures;
`;
exports.HeroText = styled_components_1.default(TextBase) `
  animation: ${Animations_1.fadein(0, 15)} 1.5s ease-out;
  color: ${Colors_1.MAKO};
  font-size: 18px;
  line-height: 28px;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    animation: ${Animations_1.fadein(0, 15)} 1s ease-in-out;
    font-size: 20px;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    font-size: 24px;
  }

  ${ScreenSizes_1.DESKTOP} {
    font-size: 32px;
    line-height: 44px;
  }
`;
exports.SectionText = styled_components_1.default(TextBase) `
  color: ${props => props.color || Colors_1.MAKO};
  font-size: 14px;
  line-height: 24px;

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    font-size: 14px;
    line-height: 24px;
  }

  ${ScreenSizes_1.DESKTOP} {
    font-size: 16px;
    line-height: 30px;
  }
`;
exports.FooterText = styled_components_1.default(TextBase) `
  color: ${Colors_1.BONDI};
  font-size: 12px;
  font-weight: 700;
  margin-left: 12px;

  ${ScreenSizes_1.DESKTOP} {
    font-size: 13px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Text.ts